export default class CameraManager {

    constructor() {

    }

    setOptions(srcType) {
        var options = {
            // Some common settings are 20, 50, and 100
            quality: 100,
            destinationType: Camera.DestinationType.DATA_URL,//FILE_URI
            // In this app, dynamically set the picture source, Camera or photo gallery
            sourceType: srcType,
            encodingType: Camera.EncodingType.JPEG,
            mediaType: Camera.MediaType.PICTURE,
            allowEdit: true,
            correctOrientation: true  //Corrects Android orientation quirks
        }
        return options;
    }

    createNewFileEntry(imgUri) {
        window.resolveLocalFileSystemURL(cordova.file.cacheDirectory, function success(dirEntry) {

            // JPEG file
            dirEntry.getFile("tempFile.jpeg", { create: true, exclusive: false }, function (fileEntry) {

            }, onErrorCreateFile);

        }, onErrorResolveUrl);
    }

    openCamera(callback) {

        var srcType = Camera.PictureSourceType.CAMERA;
        var options = this.setOptions(srcType);
        var func = this.createNewFileEntry;

        navigator.camera.getPicture((b64Data) => {
            if (callback != undefined)
                callback(b64Data);
        }, (error) => {
            
        }, options);
    }

    openFilePicker(selection) {
        var srcType = Camera.PictureSourceType.SAVEDPHOTOALBUM;
        var options = this.setOptions(srcType);
        var func = this.createNewFileEntry;

        if (selection == "picker-thmb") {
            options.targetHeight = 100;
            options.targetWidth = 100;
        }

        navigator.camera.getPicture(function cameraSuccess(imageUri) {

            // Do something with image

        }, function cameraError(error) {

        }, options);
    }


}